import useDetectKeyboardOpen from "@/hooks/useDetectKeyboardOpen";
import { IS_IOS, IS_PWA } from "@/lib/environmentDetector";
import { cn } from "@/lib/utils";

export default function BottomSpacer() {
  const isKeyboardOpen: boolean = useDetectKeyboardOpen({ delay: 0 });
  const pushContentUp = !isKeyboardOpen && IS_IOS && IS_PWA;

  return <div className={cn("w-full", pushContentUp && "h-7")}></div>;
}
